import { gql } from 'apollo-boost';

export const fragments = {

	INTAKE_QUESTIONS: {
		QUERY_RETURN: `id name ordinal questionContext`
	},

	INTAKE_QUESTION: {
		QUERY_RETURN:    `id name ordinal questionText questionContext`,
		MUTATION_RETURN: `id name ordinal questionText questionContext`,
		EDIT_FIELDS:     `
			id
			ordinal
			refIdCode
			name
			questionText
			description
	        inputType
			dataValueSetId
			categoryId
	        category{ id displayName }
	        conditions{ id conditionType targetIntakeQuestionId value }
			questionContext
			requiredInDiscovery
		`
	},

};

export const queries = {

	GET_INTAKE_QUESTIONS: ( returnQueryString = fragments.INTAKE_QUESTIONS.QUERY_RETURN ) => gql`
	  query GetIntakeQuestions( $order: [IntakeQuestionSortInput!], $where: IntakeQuestionFilterInput ){
		intakeQuestions( order: $order, where: $where){
			${ returnQueryString }
		}
	}`,

	GET_INTAKE_QUESTION: ( returnQueryString = fragments.INTAKE_QUESTION.QUERY_RETURN ) => gql`
	  query GetIntakeQuestion( $id: Uuid! ){
	    intakeQuestion( id: $id ) {
	        ${ returnQueryString }
	    }
	  }`,

	GET_UNANSWERED_INTAKE_QUESTIONS: ( returnQueryString = fragments.INTAKE_QUESTION.QUERY_RETURN ) => gql`
	  query GetUnansweredIntakeQuestions( $input: IntakeQuestionUnansweredQueryInput! ){
        unansweredIntakeQuestions( input: $input ) {
            results {
	            intakeQuestion{
	                ${ returnQueryString }
	            }
	            triggeringCondition{
					id
	                conditionType
					intakeQuestionId
					targetIntakeQuestion{
						${ returnQueryString }
					}
					targetIntakeQuestionId
					value
	            }
	            description
            }
        }
	  }`,

	GET_OBJECTIVES_FROM_INTAKE_QUESTIONS: ( returnQueryString = fragments.INTAKE_QUESTION.QUERY_RETURN ) => gql`
	  query GetObjectivesFromIntakeQuestions( $input: SubObjectivesForAnswersQueryInput! ){
        subObjectivesForAnswer( input: $input ) {
            results {
	            subObjective{
	                ${ returnQueryString }
	            }
	            triggeringCondition{
					id
	                conditionType
					value
	            }
	            description
            }
        }
	  }`
};

export const mutations = {

	CREATE_INTAKE_QUESTION: ( returnQueryString = fragments.INTAKE_QUESTION.MUTATION_RETURN ) => gql`
	  mutation CreateIntakeQuestion( $input: IntakeQuestionCreateCommandInput! ){
	    createIntakeQuestion( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,

	UPDATE_INTAKE_QUESTION: ( returnQueryString = fragments.INTAKE_QUESTION.MUTATION_RETURN ) => gql`
	  mutation UpdateIntakeQuestion( $input: IntakeQuestionUpdateCommandInput! ){
	    updateIntakeQuestion( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,

	UPDATE_INTAKE_QUESTION_ORDER: ( returnQueryString = fragments.INTAKE_QUESTIONS.QUERY_RETURN ) => gql`
	  mutation UpdateIntakeQuestionOrder( $input: IntakeQuestionUpdateOrdinalsCommandInput! ){
	    updateIntakeQuestionOrdinals( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,

	DELETE_INTAKE_QUESTION: () => gql`
	  mutation DeleteIntakeQuestion( $input: IntakeQuestionDeleteCommandInput! ){
	    deleteIntakeQuestion( input: $input )
	  }`,
};

export const functions = {}

export const IntakeQuestionQueries = {
	fragments,
	queries,
	mutations,
	functions,
};
